// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AngleDown from "@flip/XDL/Icons/AngleDown";
import AngleRight from "@flip/XDL/Icons/AngleRight";
import { xBaseTheme } from "@flip/XDL/types";
import PanelMenuDefaultProps from "@insite/mobius/PanelMenu/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PanelMenuDefaultProps,
        mergeCss: true,
        panelRowProps: {
            color: "primary",
            moreIconProps: {
                src: AngleRight,
                size: 10,
                color: "secondary",
                css: css`
                    width: 100%;
                    justify-content: flex-end;
                `,
            },
        },
        backIconProps: { src: AngleDown, color: "text", size: 7 },
        childTypographyProps: {
            size: 16,
            weight: 500,
            lineHeight: "26px",
            css: css`
                letter-spacing: 0;
            `,
        },
    },
} as xBaseTheme["panelMenu"];
